import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { GalleryService } from '../../../services/gallery.service';
import { GalleryApiItem } from '../../../models/gallery.model';
import { Loading } from '../../layouts/loading/loading';

declare var $: any;

@Component({
  selector: 'app-galerie-detail',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, TranslatePipe, Loading],
  templateUrl: './galerie-detail.html',
  styleUrl: './galerie-detail.css',
})
export class GalerieDetailComponent implements OnInit, AfterViewInit {
  gallery: GalleryApiItem | null = null;
  loading = true;
  error   = '';

  // Lightbox maison (fallback si Magnific non dispo)
  lightboxOpen  = false;
  lightboxIndex = 0;

  constructor(
    private route: ActivatedRoute,
    private galleryService: GalleryService,
  ) {}

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (!id) { this.error = 'galerie_erreur_id'; this.loading = false; return; }

    this.galleryService.getGallery(id).subscribe({
      next: res => {
        this.gallery = res.data ?? (res as any);
        this.loading = false;
        // Init Magnific Popup après rendu
        setTimeout(() => this.initMagnific(), 300);
      },
      error: () => {
        this.error   = 'galerie_erreur_chargement';
        this.loading = false;
      },
    });
  }

  ngAfterViewInit(): void {}

  private initMagnific(): void {
    if (typeof $ !== 'undefined' && $.fn?.magnificPopup) {
      $('.gallery-detail__popup').magnificPopup({
        type: 'image',
        gallery: { enabled: true },
        image: { titleSrc: 'title' },
      });
    }
  }

  isVideo(media: { mime_type: string }): boolean {
    return media.mime_type?.startsWith('video/') ?? false;
  }

  getFeatured(): string {
    if (!this.gallery) return '/assets/images/default_image.png';
    if (this.gallery.featured_image) return this.gallery.featured_image;
    if (this.gallery.gallery?.length) return this.gallery.gallery[0].url;
    return '/assets/images/default_image.png';
  }

  // ── Lightbox maison ──────────────────────────────────────────────────
  openLightbox(index: number): void {
    this.lightboxIndex = index;
    this.lightboxOpen  = true;
  }

  closeLightbox(): void {
    this.lightboxOpen = false;
  }

  prevMedia(): void {
    const len = this.gallery?.gallery?.length ?? 0;
    this.lightboxIndex = (this.lightboxIndex - 1 + len) % len;
  }

  nextMedia(): void {
    const len = this.gallery?.gallery?.length ?? 0;
    this.lightboxIndex = (this.lightboxIndex + 1) % len;
  }

  get currentMedia(): { url: string; thumb: string; mime_type: string } | null {
    return this.gallery?.gallery?.[this.lightboxIndex] ?? null;
  }

  getDelay(i: number): string {
    return `${(i % 6) * 80}ms`;
  }
}
